import React, { useEffect } from "react";
import { useTranslation, Trans} from "react-i18next";
import basket from "../assets/images/basket.png";
import guarantee from "../assets/images/guarantee.png";
import pl_fidelity_card from "../assets/images/pl_fidelity_card.svg";
import pl_flowing_water from "../assets/videos/pl_flowing_water.mp4";
import {triggerFadeInOnScrollPricing} from "../assets/js/swithalert";
import config from "../config";
import Breadcrumb from "../components/Breadcrumb";


function Pricing() {

  const {t} = useTranslation();

  useEffect(() => {
    triggerFadeInOnScrollPricing();
  }, []);

  return (
    <div className="main">
        <div class="section_pricing_top" data-aos="">
            <div class="video-container">
                <Breadcrumb />
                <video className="d-block w-100" autoPlay loop muted>
                    <source src="https://www.pristane-laverie.com/videos/pl_flowing_water.mp4" type="video/mp4" />
                </video>
                <h2>
                    <Trans i18nKey="pricing_top_title" 
                        values={{ brand: config.brand}}>
                    </Trans>
                </h2>
                <h4>
                <Trans i18nKey="pricing_top_subtitle" 
                    values={{ brand: config.brand, reducePourcentage: config.reducePercentage}}>
                </Trans>
                </h4>
            </div>          

        </div>
        <div class="section_pricing_middle" data-aos="">
            <div class="subtitle">
                <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                </div>           
                <h2 class="">Tarifs</h2>
            </div> 
            <div class="content">
                <p class="text-center pt-4 p1">
                    <Trans i18nKey="pricing_middle_text_1" 
                        values={{ brand: config.brand, reducePourcentage: config.reducePercentage}}>
                    </Trans>
                </p>    
                <p class="text-center p2">
                    <Trans i18nKey="pricing_middle_text_2"></Trans>
                </p>
                <p class="text-center pb-4 p3">
                    <Trans i18nKey="pricing_middle_text_3" 
                        values={{ brand: config.brand}}>
                    </Trans>
                </p>
                <div class="row align-items-center prices tb1">
                    <div class="col-12 col-md-6">
                        <h2 itemprop="name">{t("pricing_middle_wash")}</h2>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="row">
                            <div class="col-2"></div>
                            <div class="col-5 small-title text-center normal-price"><Trans i18nKey="pricing_middle_text_4"></Trans></div>
                            <div class="col-5 small-title text-center normal-price"><Trans i18nKey="pricing_middle_text_5"></Trans></div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">30MIN<br/>7KG</div>
                            <div class="col-5 normal text-center normal-price">5.5€</div>
                            <div class="col-5 red text-center reduce-price">
                                <span content="5.40" >4.95</span><span content="EUR" itemprop="priceCurrency">€</span>
                            </div>
                         </div>
                         <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">30MIN<br/>9KG</div>
                            <div class="col-5 normal text-center normal-price">6.3€</div>
                            <div class="col-5 red text-center reduce-price">
                                <span content="5.40" >5.67</span><span content="EUR" itemprop="priceCurrency">€</span>
                            </div>
                         </div>
                         <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">30MIN<br/>13KG</div>
                            <div class="col-5 normal text-center normal-price">8.5€</div>
                            <div class="col-5 red text-center reduce-price">
                                <span content="5.40" >7.65</span><span content="EUR" itemprop="priceCurrency">€</span>
                            </div>
                         </div>
                        <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">30MIN<br/>15KG</div>
                            <div class="col-5 normal text-center normal-price">10€</div>
                            <div class="col-5 red text-center reduce-price">9.00€</div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">30MIN<br/>20KG</div>
                            <div class="col-5 normal text-center normal-price">13.3€</div>
                            <div class="col-5 red text-center reduce-price">11.97€</div>
                        </div>
                    </div>
                </div>
                <div class="row pt-5 align-items-center prices tb2">
                    <div class="col-12 col-md-6">
                        <h2 itemprop="name">{t("pricing_middle_dry")}</h2>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">5MIN<br/>13.5KG</div>
                            <div class="col-5 normal text-center normal-price">1.5€</div>
                            <div class="col-5 red text-center reduce-price">1.35€</div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-2 small-title normal-price">5MIN<br/>20KG</div>
                            <div class="col-5 normal text-center normal-price">3€</div>
                            <div class="col-5 red text-center reduce-price">2.70€</div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center pt-5 prices tb3">
                    <div class="col-12 col-md-6 col1">
                        <span class="title d-block">{t("pricing_middle_text_6")}</span>
                        <span class="percent d-block">
                            <Trans i18nKey="pricing_middle_text_7" 
                                values={{reducePourcentage: config.reducePercentage}}>
                            </Trans>
                        </span>
                        <span class="description d-block">{t("pricing_middle_text_8")}</span>
                    </div>
                    <div class="col-12 col-md-6 col2">
                        <img alt="fedelity card" width="374px" height="225px" src={pl_fidelity_card}/>
                    </div>
                </div>
                <div class="row mt-4">
                    
                    <p class="text-center try_garentee mb-0">
                        <img src={basket} class="" style={{"max-width":"64px"}}/>
                        <Trans i18nKey="try_garentee_text"></Trans>
                        <img src={guarantee} class="pb-2" style={{"max-width":"51px", "padding-left":"6px"}}/>
                    </p>
        
                </div>
                
            </div>
        </div>
      
    </div>
  );
}

export default Pricing;
